
import { Referral } from '@/components/ReferralList';

export const calculateReferralStats = (referrals: Referral[] = []) => {
  const totalReferrals = referrals.length;
  const pendingReferrals = referrals.filter(r => r.status === 'pending').length;
  const approvedReferrals = referrals.filter(r => r.status === 'approved').length;
  const rejectedReferrals = referrals.filter(r => r.status === 'rejected').length;
  
  const successRate = totalReferrals > 0 
    ? Math.round((approvedReferrals / totalReferrals) * 100) 
    : 0;
  
  return {
    totalReferrals,
    pendingReferrals,
    approvedReferrals,
    rejectedReferrals,
    successRate
  };
};
